var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "agreement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3828 10.125H29.1995C28.2978 10.125 27.8469 10.125 27.4218 9.99627C26.9967 9.86755 26.6216 9.61747 25.8713 9.1173C24.746 8.36704 23.4621 7.51117 22.8243 7.31808C22.1867 7.125 21.5103 7.125 20.1578 7.125C18.3185 7.125 17.1329 7.125 16.3059 7.46754C15.479 7.81008 14.8287 8.4604 13.528 9.76104L12.3834 10.9057C12.0903 11.1988 11.9437 11.3453 11.8532 11.49C11.5178 12.0264 11.555 12.7156 11.9461 13.2128C12.0517 13.3469 12.2131 13.4768 12.5361 13.7367C13.7298 14.6974 15.4506 14.6015 16.5315 13.5141L18.3828 11.6518H19.8828L28.8828 20.7054C29.7113 21.5388 29.7113 22.8898 28.8828 23.7232C28.0544 24.5566 26.7113 24.5566 25.8828 23.7232L25.1328 22.9687M25.1328 22.9687L20.6328 18.442M25.1328 22.9687C25.9613 23.8021 25.9613 25.1533 25.1328 25.9866C24.3044 26.82 22.9613 26.82 22.1328 25.9866L20.6328 24.4777M20.6328 24.4777C21.4613 25.311 21.4613 26.6622 20.6328 27.4956C19.8044 28.3288 18.4613 28.3288 17.6328 27.4956L15.3828 25.2321M20.6328 24.4777L17.6328 21.4777M15.3828 25.2321L14.6328 24.4777M15.3828 25.2321C16.2113 26.0655 16.2113 27.4167 15.3828 28.2501C14.5544 29.0833 13.2112 29.0833 12.3828 28.2501L8.14737 23.9263C7.27704 23.0379 6.84187 22.5937 6.28434 22.3593C5.7268 22.125 5.10493 22.125 3.86122 22.125H3.38281",
    stroke: "#053CC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.3828 22.125H29.6328",
    stroke: "#053CC8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.1328 10.125H3.38281",
    stroke: "#053CC8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.3dae91308fb4a9d6b8dc78da12010ed8.svg";
export { ForwardRef as ReactComponent };